//文字コードはutf-8

import { initDrawer } from './modules/drawer.js';
import { initHeaderScroll } from './modules/header.js';
import { initCarousel } from './modules/carousel.js';
import { initBusinessMap } from './modules/businessMap.js';
import { initFooterMascots } from './modules/footer.js';
import { initHoverSlide } from './modules/hoverSlide.js';
import { initTitleReveal } from './modules/titleReveal.js';
import { initFileUpload } from './modules/fileUpload.js';
import { initKvLottie } from './modules/kvLottie.js';
import { initContactLottie } from './modules/contact.js';

initDrawer();
initHeaderScroll();
initCarousel();
initBusinessMap();
initFooterMascots();
initHoverSlide();
initTitleReveal();
initFileUpload();
initKvLottie();
initContactLottie();
